import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  ICategorieGetIdModel,
  ModelNumStr,
  ModelNumStrNav,
  TicketsCategorieSub,
  ITicketsGruppiCategoriaSub,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsCategorieSubService extends CrudGenericsService<TicketsCategorieSub, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsCategorieSub`);
    this.base = `${env.apiUrl}/api/TicketsCategorieSub/`;
  }
  // per ionic add
  public Get4Select_CategoriaNavigation(): Observable<ModelNumStrNav[]> {
    const url = this.base + 'Get4Select_CategoriaNavigation';
    return this.http.get<ModelNumStrNav[]>(`${url}`);
  }

  public Get4Select_From_IdCategoria(id: any): Observable<ModelNumStrNav[]> {
    const url = this.base + 'Get4Select_From_IdCategoria';
    let data = { idCategoria: id };
    return this.http.get<ModelNumStrNav[]>(`${url}`, { params: data });
  }

  // per le select categorie
  public GetSelected_CategorieGetIdModel(model: ICategorieGetIdModel): Observable<ICategorieGetIdModel[]> {
    const url = this.base + 'GetSelected_CategorieGetIdModel';
    return this.http.post<ICategorieGetIdModel[]>(`${url}`, model);
  }

  Save_Gruppi(dati: ITicketsGruppiCategoriaSub) {
    const url = this.base + 'Save_Gruppi';
    return this._http.post<ITicketsGruppiCategoriaSub>(url, dati);
  }
}
